import { isTag } from 'anodum';
import view from '../../view';
import hdrm from '../../hdrm';
import getGlobalFromChild from './get-global-from-child';
import constants from '../constants';
import getGlobalBySource from '../selectors/global-by-source';
import isElementDetached from '../verifiers/is-element-detached';

const getModifiedGlobals = (state, action) => {
  const listOfGlobalElementsIds = new Set();
  const { elementId, refElementId, containerId, targetElementId, options } = action.payload;

  function findGlobals(childId) {
    if (childId) {
      const containerGlobalId = getGlobalFromChild(childId, options);

      if (containerGlobalId) {
        listOfGlobalElementsIds.add(containerGlobalId);
      }
    }
  }

  function processChildrenPresence(containerElementId, childrenPresenceUpdates) {
    const containerElement = view.accessors.getLiveElement(containerElementId);

    findGlobals(containerElementId);

    childrenPresenceUpdates.forEach((childrenPresenceSetting) => {
      const changedNodes = hdrm.accessors.getNodesByPresenceSetting(
        containerElement,
        childrenPresenceSetting
      );

      changedNodes.forEach((changedNode) => {
        const closestReferenceId = hdrm.accessors.getClosestReferenceId(changedNode);
        const closestReference = view.accessors.getLiveElement(closestReferenceId);

        if (closestReferenceId && isTag(closestReference, constants.GLOBAL_TAG_NAME)) {
          listOfGlobalElementsIds.add(closestReferenceId);
        }

        findGlobals(closestReferenceId);
      });
    });
  }

  findGlobals(elementId);
  findGlobals(refElementId);
  findGlobals(targetElementId);

  switch (action.type) {
    case view.actionTypes.SYNCHRONIZE_ELEMENT: {
      const liveElement = view.accessors.getLiveElement(elementId);
      const nestedGlobalElements = liveElement.querySelectorAll(constants.GLOBAL_TAG_NAME);

      nestedGlobalElements.forEach((globalNode) => {
        listOfGlobalElementsIds.add(view.accessors.getLiveElementId(globalNode));
      });

      break;
    }

    case view.actionTypes.SET_CHILDREN_PRESENCE: {
      const { childrenPresenceUpdate } = action.payload;

      processChildrenPresence(containerId, [childrenPresenceUpdate]);
      break;
    }

    case view.actionTypes.BULK_SET_CHILDREN_PRESENCE: {
      const { childrenPresenceUpdates } = action.payload;

      processChildrenPresence(containerId, childrenPresenceUpdates);
      break;
    }
    default:
  }

  return [...listOfGlobalElementsIds].reduce((acc, globalElementId) => {
    const globalElement = view.accessors.getLiveElement(globalElementId);
    const globalSrc = globalElement.getAttribute('src');
    const global = getGlobalBySource(state, globalSrc);
    if (!global || isElementDetached(globalElement)) return acc;

    acc.push({
      id: global.id,
      source: global.source,
      elementId: globalElementId,
    });

    return acc;
  }, []);
};

export default getModifiedGlobals;
